import { render, staticRenderFns } from "./CreateCharacter.vue?vue&type=template&id=0f025ef8&scoped=true"
import script from "./create_character.js?vue&type=script&lang=js&external"
export * from "./create_character.js?vue&type=script&lang=js&external"
import style0 from "./create_character.scss?vue&type=style&index=0&id=0f025ef8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f025ef8",
  null
  
)

export default component.exports